import React, { useState } from 'react';
import { useNavigate, Link, useSearchParams } from 'react-router-dom'; 
import axiosClient from '../../api/axiosClient';
import { ShieldCheck, Loader2, Mail } from 'lucide-react';

const RegisterPage = () => {
  const [step, setStep] = useState(1); // 1=Form, 2=OTP
  const [formData, setFormData] = useState({ full_name: '', email: '', password: '' });
  const [otp, setOtp] = useState('');
  const [loading, setLoading] = useState(false);
  
  const navigate = useNavigate();
  const [searchParams] = useSearchParams(); // Capture URL params
  const planIntent = searchParams.get('plan'); // Check if user wants to buy a plan

  const handleRegister = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
        await axiosClient.post('/auth/register', formData);
        setStep(2);
    } catch (err) {
        alert(err.response?.data?.detail || "Registration failed");
    } finally { setLoading(false); }
  };

  const handleVerify = async (e) => {
      e.preventDefault();
      setLoading(true);
      try {
          await axiosClient.post('/auth/verify-otp', { email: formData.email, otp });
          alert("Verified! Please Login.");
          
          // Redirect to Login WITH the plan intent
          if (planIntent) {
              navigate(`/login?plan=${planIntent}`);
          } else {
              navigate('/login');
          }
      } catch (err) {
          alert("Invalid OTP");
      } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen bg-slate-900 flex items-center justify-center p-4">
       <div className="max-w-md w-full bg-white rounded-2xl shadow-2xl overflow-hidden p-8">
          <div className="text-center mb-8">
             <ShieldCheck className="w-12 h-12 text-blue-600 mx-auto mb-2"/>
             <h2 className="text-2xl font-bold text-slate-800">Create Secure Account</h2>
             <p className="text-slate-500 text-sm">Join the AIRS Defense Grid</p>
          </div>

          {step === 1 ? (
              <form onSubmit={handleRegister} className="space-y-4">
                  <input 
                    className="w-full p-3 border rounded-lg bg-slate-50 focus:ring-2 focus:ring-blue-500 outline-none" 
                    placeholder="Full Name" 
                    required 
                    onChange={e => setFormData({...formData, full_name: e.target.value})} 
                  />
                  <input 
                    className="w-full p-3 border rounded-lg bg-slate-50 focus:ring-2 focus:ring-blue-500 outline-none" 
                    type="email" 
                    placeholder="Email Address" 
                    required 
                    onChange={e => setFormData({...formData, email: e.target.value})} 
                  />
                  <input 
                    className="w-full p-3 border rounded-lg bg-slate-50 focus:ring-2 focus:ring-blue-500 outline-none" 
                    type="password" 
                    placeholder="Password" 
                    required 
                    onChange={e => setFormData({...formData, password: e.target.value})} 
                  />
                  <button disabled={loading} className="w-full bg-blue-600 text-white py-3 rounded-xl font-bold hover:bg-blue-700 flex justify-center transition-all">
                     {loading ? <Loader2 className="animate-spin"/> : "Get OTP"}
                  </button>
              </form>
          ) : (
              <form onSubmit={handleVerify} className="space-y-4 animate-in fade-in">
                  <div className="text-center bg-blue-50 p-4 rounded-lg border border-blue-100 mb-4">
                      <Mail className="w-6 h-6 text-blue-500 mx-auto mb-1"/>
                      <p className="text-xs text-blue-700">OTP sent to {formData.email}</p>
                  </div>
                  
                  {/* OTP INPUT */}
                  <input 
                      type="text"
                      name="otp_verify_code"
                      id="otp_verify_code"
                      autoComplete="one-time-code"
                      inputMode="numeric"
                      pattern="[0-9]*"
                      autoFocus
                      className="w-full p-3 border rounded-lg text-center font-mono text-xl tracking-widest bg-white focus:ring-2 focus:ring-green-500 outline-none transition-all" 
                      placeholder="000000" 
                      maxLength={6} 
                      required 
                      value={otp}
                      onChange={e => {
                          const val = e.target.value.replace(/[^0-9]/g, '');
                          setOtp(val);
                      }} 
                  />
                  
                  <button disabled={loading} className="w-full bg-green-600 text-white py-3 rounded-xl font-bold hover:bg-green-700 flex justify-center transition-all">
                     {loading ? <Loader2 className="animate-spin"/> : "Verify & Activate"}
                  </button>
              </form>
          )}
          
          <div className="mt-6 text-center text-sm text-slate-500">
             {/* ✅ FIX: If user clicks Login here, keep the plan intent */}
             Already have an account? <Link to={planIntent ? `/login?plan=${planIntent}` : "/login"} className="text-blue-600 font-bold hover:underline">Login</Link>
          </div>
       </div>
    </div>
  );
};

export default RegisterPage;